"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TextPairingContext: function() {
        return TextPairingContext;
    },
    TextPairing: function() {
        return TextPairing;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _system = require("@chakra-ui/system");
var _hooks = require("../../../hooks");
var _components = require("../..");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TextPairingContext = (0, _react.createContext)({
    labelVariant: null,
    subLabelVariant: null
});
var TextPairing = function(_param) {
    var variant = _param.variant, props = _object_without_properties(_param, [
        "variant"
    ]);
    var responsiveVariant = (0, _hooks.useResponsiveValue)(variant);
    var _useMultiStyleConfig = (0, _system.useMultiStyleConfig)("TextPairing", {
        variant: responsiveVariant
    }), container = _useMultiStyleConfig.container, label = _useMultiStyleConfig.label, subLabel = _useMultiStyleConfig.subLabel;
    return _react.default.createElement(TextPairingContext.Provider, {
        value: {
            labelVariant: label.variant,
            subLabelVariant: subLabel.variant
        }
    }, _react.default.createElement(_components.Flex, _object_spread({
        flexDirection: "column"
    }, container, props)));
};
var TextPairingText = function(_param) {
    var variantProp = _param.variantProp, props = _object_without_properties(_param, [
        "variantProp"
    ]);
    var context = (0, _react.useContext)(TextPairingContext);
    return _react.default.createElement(_components.Text, _object_spread({
        variant: context[variantProp]
    }, props));
};
TextPairing.Label = function(props) {
    return _react.default.createElement(TextPairingText, _object_spread_props(_object_spread({}, props), {
        variantProp: "labelVariant"
    }));
};
TextPairing.SubLabel = function(props) {
    return _react.default.createElement(TextPairingText, _object_spread_props(_object_spread({}, props), {
        variantProp: "subLabelVariant"
    }));
};
